import {
  ISearchSlim360O365UserCopilotActivitySummary,
  ISlim360O365UserCopilotActivitySummary,
} from '../../../services/slim360/o365UserCopilotActivitySummary/o365UserCopilotActivitySummary.model';
import o365UserCopilotActivitySummaryService from '../../../services/slim360/o365UserCopilotActivitySummary/o365UserCopilotActivitySummary.service';
import { createAsyncThunk } from '@reduxjs/toolkit';

// Asynchronous thunk action

export const searchSlim360O365UserCopilotActivitySummary = createAsyncThunk(
  'searchSlim360O365UserCopilotActivitySummary',
  async (searchParam?: ISearchSlim360O365UserCopilotActivitySummary) => {
    const response = await o365UserCopilotActivitySummaryService
      .searchSlim360O365UserCopilotActivitySummary(searchParam)
      .then((res) => {
        return res.body;
      });
    return response.data;
  }
);

export const getSlim360O365UserCopilotActivitySummaryById = createAsyncThunk(
  'getSlim360O365UserCopilotActivitySummaryById',
  async (id: number) => {
    const response = await o365UserCopilotActivitySummaryService
      .getSlim360O365UserCopilotActivitySummaryById(id)
      .then((res) => {
        return res.body;
      });
    return response.data;
  }
);

export const saveSlim360O365UserCopilotActivitySummary = createAsyncThunk(
  'saveSlim360O365UserCopilotActivitySummary',
  async (data: ISlim360O365UserCopilotActivitySummary) => {
    const response = await o365UserCopilotActivitySummaryService
      .saveSlim360O365UserCopilotActivitySummary(data)
      .then((res) => {
        return res.body;
      });
    return response;
  }
);

export const deleteSlim360O365UserCopilotActivitySummary = createAsyncThunk(
  'deleteSlim360O365UserCopilotActivitySummary',
  async (id: number) => {
    const response = await o365UserCopilotActivitySummaryService
      .deleteSlim360O365UserCopilotActivitySummary(id)
      .then((res) => {
        return res.body;
      });
    return response;
  }
);
